import React from 'react';
import styles from './styles.module.scss';
import Button from 'src/Components/Button_V2';
import icLock from 'assets/svg/ic_lock.svg';
import icLockDisabled from 'assets/svg/ic_lock_disabled.svg';
import { StakingPlan } from 'src/models';
import useCheckAllowance from 'src/hooks/useCheckAllowance';
import { STAKING_ADDRESS } from 'src/constants';

const StakeAndLock = ({
  showConfirmForm,
  planStake,
  numberSelected,
  totalPrice
}) => {
  const {
    approveUseBalance,
    isEnoughAllowance,
    isProcessing
  } = useCheckAllowance({
    contractAddress: STAKING_ADDRESS,
    thresholdPrice: totalPrice
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, isEnoughAllowance ? /*#__PURE__*/React.createElement(Button, {
    title: "Stake and Lock",
    type: "warning",
    icon: numberSelected ? icLock : icLockDisabled,
    className: styles.btnStake,
    onClick: showConfirmForm,
    disabled: !numberSelected
  }) : /*#__PURE__*/React.createElement(Button, {
    title: "Approve",
    type: "warning",
    className: styles.btnStake,
    onClick: async () => {
      await approveUseBalance();
    },
    disabled: isProcessing
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.fullWidth
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.noticePlan
  }, /*#__PURE__*/React.createElement("span", null, "Your THG token will be locked for\xA0", planStake === StakingPlan.ONE_YEAR ? 12 : 6, " months You can unstake after the due date."))));
};

export default StakeAndLock;